import React, { useState } from "react";
import './WebDesign.css';
import software from './assets/Software.avif';
import softwaredevelopment from './assets/softwaredevelopment.avif';
import softwareoffer from './assets/softwareoffer.jpg';

const Software = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Software</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Software</span>
                        </p>
                    </div>
                </div>
            </section>

            <div className="company-section py-5">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Software Solutions – Custom Solutions for Your Unique Needs</h2>
                            <p>Your business has unique needs that off-the-shelf software may not address. That’s where we come in. Dot Localhost develops custom software solutions designed to streamline processes, increase efficiency, and solve your specific challenges. From customer relationship management (CRM) systems to enterprise-level applications, we create tailored software that supports your business goals.</p>
                            <h3>Why Custom Software Solutions Matter</h3>
                            <p>Standard software solutions often come with limitations that may not fully align with your business operations. Custom software ensures a perfect fit, increasing productivity and providing a seamless user experience.</p>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={software} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={softwaredevelopment} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>Our Software Development Process</h3>                                
                                <ol>
                                    <li><b>Requirement Analysis:</b> Understanding business needs to define software functionalities.</li>
                                    <li><b>Custom Development:</b> Tailoring solutions to address unique business challenges.</li>
                                    <li><b>Testing & Quality Assurance:</b> Ensuring software reliability and performance.</li>
                                    <li><b>Implementation & Support:</b> Deploying software and providing ongoing technical support.</li>
                                </ol>
                            </div>
                        </div>                        
                    </div>

                    <div className="row">                        
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>What We Offer</h3>                                
                                <ol>
                                    <li><b>Custom Software Development:</b> Tailored solutions designed for efficiency and scalability.</li>
                                    <li><b>Enterprise Resource Planning (ERP) Systems:</b> Integrated tools to streamline business operations.</li>
                                    <li><b>Cloud-Based & Scalable Solutions:</b> Flexible, secure, and scalable software.</li>
                                    <li><b>CRM Systems & Automation Tools:</b> Improving customer relationships and workflow automation.</li>
                                </ol>
                            </div>
                        </div>  
                        <div className="col-md-6 side-images py-5">
                            <img src={softwareoffer} alt="Mobile Optimization" className="mt-3" />
                        </div>                      
                    </div>

                    <section className="hero-section text-column mt-5">
                        <p>Our software solutions ensure seamless business operations, improving efficiency and enabling long-term growth. Let Dot Localhost develop software that fits your needs perfectly.</p>
                    </section>

                </div>
            </div>

        </>
    );
};

export default Software;